<div class="container">
  <eo-view-panel [config]="config" [headerTemplate]="headerTemplate"></eo-view-panel>
</div>
